<template>
    <table :class="getTableClasses" style="width:100%">
        <thead>
        <tr>
            <th class="text-center">#</th>
            <th class="text-center">Component Name</th>
            <th class="text-center">Item Name</th>
            <th class="text-center">Min Required</th>
            <th class="text-center">Current ROB</th>
            <th class="text-center">Status</th>
            <th class="text-center">Remarks</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="item?.id">
            <td class="text-center">
                {{ (currentPage - 1) * perPage + index + 1 }}
            </td>
            <td class="text-center">{{item?.components}}</td>
            <td class="text-center">{{item?.name}}</td>
            <td class="text-center">{{item?.min_order}}</td>
            <td class="text-center">{{item?.rob}}</td>
            <td class="text-center">
                <span class="badge badge-success" v-if="item?.rob >= item?.min_order"><i class="fa fa-arrow-up"></i></span>
                <span v-else class="badge badge-danger"><i class="fa fa-arrow-down"></i></span>
            </td>
            <td class="text-center">{{item?.description}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import PermissionsMixin from "@/mixin/permissionsMixin";
    import auth from "@/auth";

    export default {
        mixins: [PermissionsMixin],
        data() {
            return {
                permissions: auth.getPermissionData(),
            }
        },
        props: {
            items: {
                required: true
            },
            currentPage: {
                type: Number,
                default: 1
            },
            perPage: {
                type: Number,
                default: 20
            },
            isPrinting: {
                type: Boolean,
                default: false
            },
            isReport: {
                type: Boolean,
                default: false
            },
            isEmpty: {
                required: false
            }
        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                    'vertical-align-middle': true
                };
            }
        }
    };
</script>

<style scoped>
    .print-table {
        /* Define styles for printing if needed */
    }
</style>
